// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".OtherArticles__questionsContainer___24reF{position:relative;margin-top:64px}.OtherArticles__inner___1JU4x{padding:40px 24px 80px}@media (min-width:960px){.OtherArticles__inner___1JU4x{padding:80px 24px 128px}}.OtherArticles__title___22RaO{color:inherit;font-weight:500;font-size:32px;line-height:48px;max-width:700px;margin:0 auto}@media (min-width:720px){.OtherArticles__title___22RaO{text-align:center}}.OtherArticles__list___2Y0UW{display:grid;grid-gap:40px;gap:40px;margin-top:56px}@media (min-width:720px){.OtherArticles__list___2Y0UW{grid-template-columns:repeat(2,1fr)}}.OtherArticles__article___22PlA{max-width:none}@media (max-width:1279px){.OtherArticles__article___22PlA>div{flex-direction:column!important;align-items:flex-start!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"questionsContainer": "OtherArticles__questionsContainer___24reF",
	"inner": "OtherArticles__inner___1JU4x",
	"title": "OtherArticles__title___22RaO",
	"list": "OtherArticles__list___2Y0UW",
	"article": "OtherArticles__article___22PlA"
};
module.exports = ___CSS_LOADER_EXPORT___;
